import { TRUE_VALUES_FOR_COOKIE_AND_ENV_VARIABLES } from '~/utils/consts';

function waitForWaf(timeout = 4000) {
  return new Promise(resolve => {
    if (window.AwsWafIntegration) {
      return resolve(window.AwsWafIntegration);
    }

    const startTime = Date.now();
    const interval = setInterval(() => {
      if (window.AwsWafIntegration) {
        clearInterval(interval);
        resolve(window.AwsWafIntegration);
      } else if (Date.now() - startTime >= timeout) {
        clearInterval(interval);
        resolve(null);
      }
    }, 50);
  });
}

function applyToken(config, value) {
  config.headers = config.headers || {};
  config.headers['X-Aws-Waf-Token'] = value;
  return config;
}

function isChallengeResponse(response) {
  const { status, headers } = response || {};
  if (!status) return false;
  return String((headers || {})['x-amzn-waf-action'] || '').toLowerCase() === 'challenge';
}

export default function AwsWafPlugin(ctx) {
  if (!TRUE_VALUES_FOR_COOKIE_AND_ENV_VARIABLES.includes(process.env.AWS_WAF_ENABLED)) return;

  const getToken = async refresh => {
    try {
      const waf = await waitForWaf();

      if (waf) {
        return refresh ? await waf.forceRefreshToken() : await waf.getToken();
      }

      return null;
    } catch (err) {
      return null;
    }
  };

  async function replayChallenge(response) {
    const { config } = response;

    if (!config || config._isReplay) {
      return Promise.reject(new Error('AWS WAF challenge could not be solved'));
    }

    const token = await getToken();

    if (!token) {
      return Promise.reject(new Error('AWS WAF challenge could not be solved'));
    }

    config._isReplay = true;

    return ctx.$axios.request(applyToken(config, token));
  }

  ctx.$axios.interceptors.request.use(async config => {
    if (config._isReplay) return config;
    const token = await getToken();
    return token ? applyToken(config, token) : config;
  });

  ctx.$axios.interceptors.response.use(
    response => {
      return isChallengeResponse(response) ? replayChallenge(response) : response;
    },
    error => {
      const response = (error || {}).response;
      return isChallengeResponse(response) ? replayChallenge(response) : Promise.reject(error);
    }
  );
}
